export default {"src":"/_next/static/media/icon_lifetime_legenday.171b7482.svg","height":560,"width":560,"blurWidth":0,"blurHeight":0};